import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e66c5f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"main\" data-v-7e66c5f4><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-7e66c5f4><circle cx=\"30\" cy=\"30\" r=\"25\" fill=\"#39B54A\" data-v-7e66c5f4></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.6822 20.9171L26.6646 32.8953C26.3475 33.1655 25.8897 33.1875 25.5479 32.9484L20.9972 29.7583C20.6344 29.5037 20.141 29.5467 19.8276 29.8618L18.4304 31.2613C18.074 31.6185 18.074 32.1983 18.4304 32.5564L25.7362 39.8782C26.0925 40.2363 26.6719 40.2363 27.0292 39.8782L43.2628 23.6062C43.6201 23.249 43.6201 22.6692 43.2628 22.3111L41.9213 20.9665C41.5841 20.6286 41.045 20.6075 40.6822 20.9171Z\" fill=\"white\" data-v-7e66c5f4></path></svg><div class=\"title\" data-v-7e66c5f4>投保完成</div><div class=\"message\" data-v-7e66c5f4>请打开微信【极飞服务】小程序或者极飞农服查看您的保单信息</div></div>", 1)

import {} from 'vue'
import AppHeader from '@/components/Header.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'mini-pay-success',
  setup(__props) {

// 小程序投保完成后，平安的回调

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "获取投保结果" }),
    _hoisted_1
  ], 64))
}
}

})